import { useEffect } from "react";

const SITE = "Vacation Apparel";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content || "");
}

export function useSeo({ title, description, image, jsonLd, noindex = false }) {
  const ld = JSON.stringify(jsonLd || null);
  useEffect(() => {
    const full = title ? `${title} | ${SITE}` : `${SITE} | Wear Your Vacation Vibes!`;
    const url = window.location.origin + window.location.pathname;
    document.title = full;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex,nofollow" : "index,follow");
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", "website");
    if (image) setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", "summary_large_image");
    let canon = document.head.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.rel = "canonical";
      document.head.appendChild(canon);
    }
    canon.href = url;
    document.getElementById("page-jsonld")?.remove();
    const data = JSON.parse(ld);
    if (data) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = "page-jsonld";
      s.text = JSON.stringify(data);
      document.head.appendChild(s);
    }
  }, [title, description, image, ld, noindex]);
}

export const breadcrumbLd = (items) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map(([name, path], i) => ({
    "@type": "ListItem",
    position: i + 1,
    name,
    item: window.location.origin + path,
  })),
});
